import { render, staticRenderFns } from "./AL.Notices.vue?vue&type=template&id=14db7dd3&scoped=true"
import script from "./AL.Notices.vue.ts?vue&type=script&lang=ts&external"
export * from "./AL.Notices.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./AL.Notices.vue?vue&type=style&index=0&id=14db7dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db7dd3",
  null
  
)

export default component.exports